import * as React from 'react';
import { HeadingProps } from '../../../../Heading';

export type ModalHeadingProps = HeadingProps;

declare const ModalHeading: React.FunctionComponent<ModalHeadingProps>;
export default ModalHeading;
